import WriteIcon from '#assets/svg/write_icon.svg';
import { Link } from 'react-router-dom';

const WriteButton = ({
  to,
  onClick
}: {
  to?: string;
  onClick?: () => void;
}) => {
  return (
    <>
      {to ? (
        <div className="w-full fixed bottom-[9rem] pointer-events-none left-1/2 -translate-x-1/2 max-w-939 flex justify-end items-center px-20">
          <Link
            to={to}
            className="w-44 h-44 flex items-center justify-center bg-[#7750E9] rounded-full z-10 drop-shadow-lg pointer-events-auto"
          >
            <img src={WriteIcon} />
          </Link>
        </div>
      ) : (
        <div className="w-full fixed bottom-[9rem] pointer-events-none left-1/2 -translate-x-1/2 max-w-939 flex justify-end items-center px-20">
          <button
            type="button"
            onClick={onClick}
            className="w-44 h-44 flex items-center justify-center bg-[#7750E9] rounded-full z-10 drop-shadow-lg pointer-events-auto"
          >
            <img src={WriteIcon} />
          </button>
        </div>
      )}
    </>
  );
};

export default WriteButton;
